export default function Logo({ className = "" }: { className?: string }) {
  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <div className="grid h-12 w-12 place-items-center rounded-2xl bg-[#1a2a22] text-[#f6f0e8] shadow-[0_12px_30px_-18px_rgba(17,27,20,0.9)]">
        <svg viewBox="0 0 48 48" className="h-7 w-7" aria-hidden="true">
          <path
            d="M24 6c6.9 4.7 12 11.1 12 18.2 0 7-5.5 12.8-12 12.8S12 31.2 12 24.2C12 17.1 17.1 10.7 24 6Z"
            fill="currentColor"
            opacity="0.9"
          />
          <path
            d="M23.5 14c-3.4 4-5.8 7.8-5.8 11.8 0 4.4 3 7.9 6.9 7.9 2.4 0 4.6-1.2 5.8-3.1-2.9-1.2-5.4-3.7-5.4-7.2 0-3.4 1.4-6.2 3.5-9.4-1.6 0-3.4 0-5 0Z"
            fill="#cfe8d9"
          />
        </svg>
      </div>
      <div>
        <p className="text-sm font-semibold uppercase tracking-[0.25em] text-emerald-800">Rehab</p>
        <p className="text-2xl font-serif text-[#1a1c18]">Portal</p>
      </div>
    </div>
  );
}
